import { render, staticRenderFns } from "./receiver.vue?vue&type=template&id=43fd1118&scoped=true"
import script from "./receiver.vue?vue&type=script&lang=js"
export * from "./receiver.vue?vue&type=script&lang=js"
import style0 from "./receiver.vue?vue&type=style&index=0&id=43fd1118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd1118",
  null
  
)

export default component.exports